// Auto-generated search result templates map
import figureTemplate from "/home/runner/work/18thC-cats/18thC-cats/content/search/_result-figure.mdx";
export const figure = figureTemplate;
import articleTemplate from "/home/runner/work/18thC-cats/18thC-cats/content/search/_result-article.mdx";
export const article = articleTemplate;
export default { figure, article };